"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var react_router_1 = require("react-router");
var reactjs_popup_1 = __importDefault(require("reactjs-popup"));
// Import history from "../../config/history";
var localStorage_1 = __importDefault(require("../../config/localStorage"));
var orgContext_1 = require("../../context/OrgContext/orgContext");
var userContext_1 = require("../../context/UserContext/userContext");
var icons_1 = __importDefault(require("../icons"));
var LanguageContainer_1 = __importDefault(require("./LanguageContainer"));
function UserContainer() {
    var _this = this;
    // Const { user } = props;
    var t = (0, react_i18next_1.useTranslation)().t, _a = (0, react_1.useContext)(userContext_1.UserContext), setCurrentUser = _a.setCurrentUser, user = _a.user, setCurrentOrganization = (0, react_1.useContext)(orgContext_1.OrgContext).setCurrentOrganization, history = (0, react_router_1.useHistory)(), onLogoutClick = function () { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, localStorage_1.default.clear()];
                case 1:
                    _a.sent();
                    setCurrentUser({});
                    // setCurrentCountry({});
                    setCurrentOrganization({});
                    history.push("/");
                    location.reload();
                    return [2 /*return*/];
            }
        });
    }); }, onSettingsClick = function () { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            history.push("/superadmin/serviceCategory");
            return [2 /*return*/];
        });
    }); };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: "profile-name" }, user && (react_1.default.createElement(reactjs_popup_1.default, { arrow: true, className: "profile", position: "bottom center", trigger: react_1.default.createElement("div", { style: {
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "center",
                    alignItems: "center",
                } },
                react_1.default.createElement("div", { className: "headerText" }, user.name),
                react_1.default.createElement("div", { style: {
                        transform: "rotate(270deg)",
                        marginLeft: "0.5rem",
                    } },
                    react_1.default.createElement(icons_1.default, { className: "icon_orange", height: 20, name: "backArrow", width: 20 }))) },
            react_1.default.createElement(reactjs_popup_1.default, { arrow: true, 
                // className="profile"
                position: "bottom center", trigger: react_1.default.createElement("div", { style: {
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "center",
                        alignItems: "center",
                    } },
                    react_1.default.createElement("div", { className: "headerText" }, t("settings")),
                    react_1.default.createElement("div", { style: {
                            transform: "rotate(270deg)",
                            marginLeft: "0.5rem",
                        } },
                        react_1.default.createElement(icons_1.default, { className: "icon_orange", height: 20, name: "backArrow", width: 20 }))) },
                react_1.default.createElement("div", { className: "logout-content" },
                    react_1.default.createElement("a", { onClick: function () { return onSettingsClick(); } }, t("add_service_category"))),
                react_1.default.createElement("div", { className: "logout-content" }, t("add_language")))))),
        react_1.default.createElement("div", { className: "vertical-line" }),
        react_1.default.createElement("div", { style: { width: "100px" } },
            react_1.default.createElement(LanguageContainer_1.default, { iconClassName: "icon_orange" })),
        react_1.default.createElement("div", { className: "vertical-line" }),
        react_1.default.createElement("div", { onClick: function () { return onLogoutClick(); } },
            react_1.default.createElement(icons_1.default, { className: "iconLogout", height: 50, name: "logOut", width: 50 }))));
}
exports.default = UserContainer;
